import React from 'react';
import { classNames } from '../utilities';

export const CloseIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(
        'close-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="12"
      height="12"
      viewBox="0 0 14 14"
      fill="black"
      stroke="currentColor"
    >
      <path
        d="M7 6.67705L1 0.751587M7 6.67705L13 12.6025M7 6.67705L13 0.751587M7 6.67705L1 12.6025"
        stroke="#7F7F7F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
